import { render, staticRenderFns } from "./ProjectGroupsResponsible.vue?vue&type=template&id=11e2be57"
import script from "./ProjectGroupsResponsible.vue?vue&type=script&lang=js"
export * from "./ProjectGroupsResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports